// @flow

import ApiObject from '../ApiObject';


import ProductOptionValue from '../menu/ProductOptionValue';

export default class OrderProductOptionValue extends ApiObject {

  id: string;

  additionalPrice: number = 0;

  baseAdditionalPrice: number = 0;

  name: string = '';

  getTotalAdditionnalPrice(): number {
    return this.additionalPrice;
  }

  equals(other: OrderProductOptionValue) {
    return this.id === other.id;
  }

  fromProductOptionValue(value: ProductOptionValue) {
    this.id = value.id;
    this.name = value.name;
    this.baseAdditionalPrice = value.additionalPrice;
    this.additionalPrice = value.additionalPrice;

    return this;
  }

}
